import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Whether new film submissions are being accepted. Driven by SUBMISSIONS_OPEN
// on the backend, so submissions can be paused or reopened from Railway without
// a frontend deploy.
//
// Returns null while loading. A failed request counts as closed, so the site
// never advertises submissions it may not accept.
export function useSubmissionsOpen() {
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/submissions/status`)
      .then((res) => { if (!cancelled) setOpen(Boolean(res.data?.open)); })
      .catch(() => { if (!cancelled) setOpen(false); });
    return () => { cancelled = true; };
  }, []);

  return open;
}
